(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["color-squares"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__v21ColorSquares) return;
    window.__v21ColorSquares = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var swatch = target.closest('button.color-squares__swatch');
      if (!swatch) return;

      event.preventDefault();

      var card = swatch.closest('product-card');
      if (!card) return;

      var src = swatch.dataset.imageSrc;
      var srcset = swatch.dataset.imageSrcset;
      var variantId = swatch.dataset.variantId;
      var gallery = card.querySelector('.card-gallery');
      var image = gallery ? gallery.querySelector('img.product-media__image') : null;

      if (image && src) {
        if (srcset) {
          image.srcset = srcset;
        } else {
          image.removeAttribute('srcset');
        }
        image.src = src;
        image.setAttribute('alt', swatch.getAttribute('aria-label') || image.getAttribute('alt') || '');

        /* Terug naar de eerste foto als de klant in de kaart al verder had gebladerd */
        var slideshow = gallery.querySelector('slideshow-component');
        if (slideshow && typeof slideshow.select === 'function' && slideshow.current > 0) {
          slideshow.select(0, undefined, { animate: false });
        }

        if (card.hasAttribute('data-featured-media-url')) {
          card.setAttribute('data-featured-media-url', src);
        }
      }

      /* De kaart linkt daarna naar de productpagina met deze kleur al gekozen */
      if (variantId && typeof card.applyVariantToLinks === 'function') {
        try {
          card.applyVariantToLinks(variantId);
          if (card.refs && card.refs.quickAdd && typeof card.refs.quickAdd.fetchProductPage === 'function') {
            card.refs.quickAdd.fetchProductPage(card.productPageUrl);
          }
        } catch (error) {
          console.warn('[color-squares]', error);
        }
      }

      var group = swatch.closest('.color-squares');
      if (group) {
        group.querySelectorAll('button.color-squares__swatch').forEach(function (other) {
          other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
